import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { BatchEditService } from '../../services/batch-edit-service/batch-edit-service';
import { BaseModalModule } from '../base-modal.module';
import { NvDesignLibraryModule } from './../../../../nvps-libraries/design/nv-design-library.module';
import { StudentPathsModalComponent } from './student-paths-modal.component';

@NgModule({
  declarations: [StudentPathsModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
    MatMenuModule,
    NvDesignLibraryModule,
  ],
  exports: [StudentPathsModalComponent],
  providers: [BatchEditService],
  entryComponents: [StudentPathsModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudentPathsModule {}
